module.exports = __webpack_public_path__ + "static/media/hackerrankjava1.d93e4c72.png";